exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-post-content-js": () => import("./../../../src/templates/PostContent.js" /* webpackChunkName: "component---src-templates-post-content-js" */)
}

